<template>
  <el-form ref="detailForm" :model="detail" :disabled="!canEdit" :rules="rules" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
    <el-collapse v-model="activeCollapses" class="el-card-collapse">
      <el-collapse-item title="基本信息" name="Basic">
        <el-row :gutter="20">
          <el-col :xs="24" :md="10">
            <el-form-item label="所属商家" prop="shopName">
              <el-input v-if="canEdit" v-model="detail.shopName" placeholder="请输入所属商家" />
              <span v-else class="el-input">{{ detail.shopName }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item class="inline-form-item" label="优惠抵扣">
              <el-input v-if="canEdit" v-model="detail.discount" type="number" class="max-width" placeholder="优惠抵扣">
                <template slot="append">%</template>
              </el-input>
              <span v-else class="el-input max-width">{{ `${detail.discount} %` }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :md="16">
            <el-form-item label="商品名称" prop="productName">
              <el-input v-if="canEdit" v-model.trim="detail.productName" placeholder="请输入商品名称" />
              <span v-else class="el-input">{{ detail.productName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="商品图片" prop="cover">
              <div class="image-uploader">
                <el-upload
                  action="#"
                  accept="image/*"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :on-change="imageChange.bind(null, { key: 'cover' })"
                  :http-request="imageUpload.bind(null, { key: 'cover' })"
                >
                  <template v-if="coverImage.url">
                    <img :src="coverImage.url" class="avatar">
                    <div class="el-upload-img-actions">
                      <span class="el-upload-img-preview" @click.stop="imagePreview({ key: 'cover' })">
                        <i class="el-icon-zoom-in" />
                      </span>
                      <span v-if="canEdit" class="el-upload-img-delete" @click.stop="imageBeforeRemove({ key: 'cover' })">
                        <i class="el-icon-delete" />
                      </span>
                    </div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="16">
            <el-form-item label="商品轮播图" prop="galleries">
              <el-upload
                action="#"
                :limit="9"
                multiple
                accept="image/*"
                list-type="picture-card"
                :file-list="galleries"
                :on-change="imageChange.bind(null, { key: 'galleries' })"
                :on-remove="imageRemove.bind(null, { key: 'galleries' })"
                :on-preview="imagePreview.bind(null, { key: 'galleries' })"
                :http-request="imageUpload.bind(null, { key: 'galleries' })"
                :before-remove="imageBeforeRemove.bind(null, { key: 'galleries' })"
              >
                <i class="el-icon-plus" />
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="canEdit" :gutter="20">
          <el-col :xs="24" :sm="6">
            <el-form-item class="inline-form-item" label="上架">
              <el-switch v-model="detail.isOnsale" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item class="inline-form-item" label="是否审核">
              <el-switch v-model="detail.status" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>

      <el-collapse-item title="商品价格" name="Prices">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="供货价" prop="stockPrice">
              <el-input v-if="canEdit" v-model="detail.stockPrice" type="number" class="max-width" placeholder="供货价">
                <template slot="append">元</template>
              </el-input>
              <span v-else class="el-input max-width">{{ detail.stockPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="成本价" prop="costPrice">
              <el-input v-if="canEdit" v-model="detail.costPrice" type="number" class="max-width" placeholder="成本价">
                <template slot="append">元</template>
              </el-input>
              <span v-else class="el-input max-width">{{ detail.costPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="零售价" prop="retailPrice">
              <el-input v-if="canEdit" v-model="detail.retailPrice" type="number" class="max-width" placeholder="零售价">
                <template slot="append">元</template>
              </el-input>
              <span v-else class="el-input max-width">{{ detail.retailPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item price-type" label="会员价类型">
              <el-select v-model="detail.priceType" placeholder="请选择会员价类型" class="max-width" @change="priceTypeChange">
                <el-option :value="0" label="纯现金" />
                <el-option :value="1" label="纯积分" />
                <el-option :value="2" label="现金+积分" />
              </el-select>
              <!-- <el-radio-group v-model="detail.priceType" @change="priceTypeChange">
                <el-radio :label="0">纯现金</el-radio>
                <el-radio :label="1">纯积分</el-radio>
                <el-radio :label="2">现金+积分</el-radio>
              </el-radio-group> -->
            </el-form-item>
          </el-col>
          <el-col v-if="detail.priceType === 2" :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="会员价" prop="pointPrice">
              <el-input v-if="canEdit" v-model="detail.pointPrice" type="number" class="max-width" placeholder="会员价">
                <template slot="append">元</template>
              </el-input>
              <span v-else class="el-input max-width">{{ detail.pointPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="detail.priceType !== 0" :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="抵扣积分" prop="point">
              <el-input v-if="canEdit" v-model="detail.point" type="number" class="max-width" placeholder="抵扣积分">
                <template slot="append">积分</template>
              </el-input>
              <span v-else class="el-input max-width">{{ detail.point }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="库存" prop="quantity">
              <el-input v-if="canEdit" v-model="detail.quantity" type="number" class="max-width" placeholder="请输入库存" />
              <span v-else class="el-input max-width">{{ detail.quantity }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="detail.priceType !== 1" :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="惊喜倍数" prop="surprise">
              <el-input v-if="canEdit" v-model="detail.surprise" type="number" class="max-width" placeholder="请输入惊喜值倍数" />
              <span v-else class="el-input max-width">{{ detail.surprise }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>

      <el-collapse-item title="商品介绍" name="Introduction">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="planText">
              <my-editor v-model="detail.intro" :text.sync="detail.planText" :images.sync="editorImages" :auto-focus="false" :read-only="!canEdit" @change="editorChange" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
    <el-image ref="elImage" style="width: 0; height: 0;" :src="previewImg" :preview-src-list="previewList" />
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile } from '@/api/oss'
import MyEditor from '@/components/MyEditor'
import { getStoreDetail, getGoodsDetail, submitGoods } from '@/api/store'

export default {
  name: 'StoreGoodsReview',
  components: { MyEditor },
  emits: ['create'],
  props: {
    canEdit: Boolean,
    isCreate: Boolean,
    storeId: {
      type: [Number, String],
      default: ''
    },
    productId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    const checkCover = (rule, value, callback) => {
      if (!this.coverImage || !this.coverImage.url) {
        return callback('请上传商品图片')
      } else {
        callback()
      }
    }
    const checkGalleries = (rule, value, callback) => {
      if (!this.galleries || this.galleries.length === 0) {
        return callback('请至少上传一张轮播图片')
      } else {
        callback()
      }
    }
    const checkRetailPrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入零售价'))
      } else if (this.detail.costPrice && parseFloat(this.detail.costPrice) > parseFloat(value)) {
        callback(new Error('零售价不能小于成本价'))
      } else {
        callback()
      }
    }

    return {
      detail: {},
      storeInfo: null,
      loading: false,
      previewImg: '',
      previewList: [],
      galleries: [],
      editorImages: [],
      coverImage: { url: '', file: null },
      activeCollapses: ['Basic', 'Prices', 'Introduction'],
      rules: {
        shopName: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
        productName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        quantity: [{ required: true, message: '请输入库存量', trigger: 'blur' }],
        cover: [{ required: true, validator: checkCover, trigger: 'change' }],
        galleries: [{ required: true, validator: checkGalleries, trigger: 'change' }],
        planText: [{ required: true, message: '请输入商品详情介绍', trigger: 'change' }],
        stockPrice: [{ required: true, message: '请输入供货价', trigger: 'blur' }],
        costPrice: [{ required: true, message: '请输入成本价', trigger: 'blur' }],
        retailPrice: [
          { required: true, message: '请输入零售价', trigger: 'blur' },
          { validator: checkRetailPrice, trigger: 'blur' }
        ],
        pointPrice: [{ required: true, message: '请输入会员价', trigger: 'blur' }],
        point: [{ required: true, message: '请输入抵扣积分', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  watch: {
    productId: {
      deep: true,
      immediate: true,
      handler(value) {
        this.initData()
        if (value) this.fetchData()
      }
    },
    'detail.discount': {
      deep: true,
      handler(newValue) {
        if (this.detail && this.detail.retailPrice && this.detail.priceType === 2 && newValue > 0) {
          const discount = parseFloat(this.detail.retailPrice) * parseFloat(newValue) / 100
          this.detail.point = this.$util.formatNumber(discount, 2, '')
          this.detail.pointPrice = this.$util.formatNumber(parseFloat(this.detail.retailPrice) - discount, 2, '')
        }
      }
    },
    // 供货价
    'detail.stockPrice': {
      deep: true,
      handler(newValue) {
        if (this.detail && newValue > 0 && (!this.detail.costPrice || parseFloat(this.detail.costPrice) < parseFloat(newValue))) {
          // 成本价 = 进货价 x 110%
          this.detail.costPrice = this.$util.formatNumber(parseFloat(newValue) * 110 / 100, 2, '')
        }
      }
    },
    // 零售价
    'detail.retailPrice': {
      deep: true,
      handler(newValue) {
        if (this.detail && newValue > 0 && this.detail.discount && parseFloat(this.detail.discount) > 0) {
          if (this.detail.priceType === 2) {
            const discount = parseFloat(newValue) * parseFloat(this.detail.discount) * 0.01
            this.detail.point = this.$util.formatNumber(discount, 2, '')
            this.detail.pointPrice = this.$util.formatNumber(parseFloat(newValue) - discount, 2, '')
          } else if (isNaN(this.detail.point) || parseFloat(newValue) > parseFloat(this.detail.point)) {
            this.detail.pointPrice = 0
            this.detail.point = this.$util.formatNumber(newValue, 2, '')
          }
        }
      }
    }
  },
  methods: {
    initData() {
      this.detail = Object.assign({}, {
        shopId: this.storeId || '',
        costPrice: '',
        priceType: 2,
        pointPrice: '',
        point: '',
        surprise: 0
      })
      this.galleries = []
      this.editorImages = []
      this.coverImage = { url: '', file: null }
      if (this.storeId && this.isCreate) {
        getStoreDetail(this.storeId).then(response => {
          this.detail = Object.assign({}, this.detail, {
            shopName: response.shopName,
            discount: response.discount
          })
        })
      }
    },
    fetchData() {
      const params = {
        shopId: this.storeId,
        goodsId: this.productId
      }
      this.galleries = []
      this.coverImage = {}
      this.editorImages = []
      getGoodsDetail(params).then(response => {
        const images = this.$util.getElementsByType(response.intro, 'img')
        if (images && images.length) this.editorImages = images.map(img => { return { url: img.src, old: img.src, file: null } })

        if (response.cover) this.coverImage = Object.assign({}, { url: response.cover, file: null })
        if (response.galleries && response.galleries.length) this.galleries = response.galleries.map(item => { return { url: item, file: null } })
        this.detail = response
      })
    },
    priceTypeChange(e) {
      if (!isNaN(this.detail.retailPrice)) {
        const price = parseFloat(this.detail.retailPrice)
        if (e === 0) {
          this.detail = Object.assign({}, this.detail, {
            pointPrice: 0,
            point: 0
          })
        } else if (e === 1) {
          this.detail = Object.assign({}, this.detail, {
            pointPrice: 0,
            point: this.$util.formatNumber(price, 2, '')
          })
        } else if (!isNaN(this.detail.discount) && parseFloat(this.detail.discount) > 0) {
          const discount = parseFloat(price) * parseFloat(this.detail.discount) * 0.01
          this.detail.point = this.$util.formatNumber(discount, 2, '')
          this.detail.pointPrice = this.$util.formatNumber(price - discount, 2, '')
        }
      }
    },
    imageChange(obj, file, files) {
      if (file) {
        if (obj.key === 'cover') {
          this.coverImage.url = URL.createObjectURL(file.raw)
          this.$refs.detailForm.validateField('cover')
        } else {
          this.galleries = files.map(image => {
            return { uid: image.uid, url: image.url, file: image.file || null }
          })
          this.$refs.detailForm.validateField('galleries')
        }
      }
    },
    imageUpload(obj, form) {
      const formData = new FormData()
      formData.append('file', form.file)
      formData.append('name', form.file.name)
      formData.append('fileSize', form.file.size)
      formData.append('fileType', form.file.type)

      if (obj.key === 'cover') {
        this.coverImage.file = formData
      } else {
        const image = this.galleries.filter(item => item.uid === form.file.uid)
        if (image && image.length) image[0].file = formData
        this.$refs.detailForm.validateField('galleries')
      }
    },
    imagePreview(obj, file) {
      const imageUrl = obj.key === 'cover' ? this.coverImage.url : file.url
      this.previewImg = imageUrl
      this.previewList = [imageUrl]
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    imageBeforeRemove(obj, file) {
      if (obj.key === 'cover') {
        this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
          this.imageRemove(obj, file)
        }).catch(() => {})
      } else {
        return this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' })
      }
    },
    imageRemove(obj, file) {
      if (obj.key === 'cover') {
        this.coverImage = Object.assign({}, { url: '', file: null })
        this.$refs.detailForm.validateField('cover')
      } else {
        const index = this.galleries.findIndex(item => item.uid === file.uid)
        this.galleries.splice(index, 1)
        this.$refs.detailForm.validateField('galleries')
      }
    },
    editorChange() {
      this.$refs.detailForm.validateField('planText')
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        const uploadPromises = []
        const files = this.galleries.filter(item => !!item.file)
        if (files && files.length) files.forEach(item => uploadPromises.push(uploadFile(item.file)))

        const editorFiles = this.editorImages.filter(item => !!item.file)
        if (editorFiles && editorFiles.length) editorFiles.forEach(item => uploadPromises.push(uploadFile(item.file)))

        if (this.coverImage.file) uploadPromises.push(uploadFile(this.coverImage.file))
        if (uploadPromises && uploadPromises.length) {
          Promise.all(uploadPromises).then(response => {
            const filesLength = (files && files.length) ? files.length : 0
            if (filesLength > 0) {
              files.forEach((item, index) => {
                const oIndex = this.galleries.findIndex(img => img.url === item.url)
                if (oIndex >= 0) this.galleries.splice(oIndex, 1, Object.assign({}, item, { url: response[index], file: null }))
              })
            }

            if (editorFiles && editorFiles.length) {
              editorFiles.forEach((item, index) => {
                const oIndex = this.editorImages.findIndex(img => img.url === item.url)
                if (oIndex >= 0) this.editorImages.splice(oIndex, 1, Object.assign({}, item, { url: response[filesLength + index], file: null }))
              })
            }
            this.editorImages.forEach(item => {
              this.detail.intro = `${this.detail.intro}`.replace(item.old, item.url)
            })
            if (this.coverImage.file) this.coverImage = { url: response[response.length - 1], file: null }
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    onSave() {
      return new Promise((resolve, reject) => {
        this.$refs.detailForm.validate((valid) => {
          if (!valid) { reject(); return false }

          this.uploadImages().then(() => {
            this.detail.cover = this.coverImage.url
            this.detail.galleries = this.galleries.map(item => item.url)
            if (this.detail.priceType === 0) this.detail = Object.assign({}, this.detail, { point: 0, pointPrice: 0 })
            if (this.detail.priceType === 1) this.detail = Object.assign({}, this.detail, { pointPrice: 0 })

            delete this.detail.planText
            return submitGoods(this.detail)
          }).then(response => {
            resolve(response)
          }).catch(() => {
            reject('商品数据提交保存失败')
          })
        })
      })
    },
    onCreateNew() {
      this.coverImage = {}
      this.galleries = []
      this.editorImages = []
      if (this.productId) {
        this.$emit('create')
      } else {
        this.$refs.detailForm.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item .el-icon-warning-outline {
  margin-left: 8px;
  font-size: 18px;
  color: #e6a23c;
}
span.el-input {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}
.mobile {
  .el-image {
    width: 138px;
    height: 138px;
  }
  .inline-form-item ::v-deep {
    .el-form-item__label {
      width: 90px;
    }
    .max-width {
      max-width: 100%;
    }
  }
  .inline-form-item.price-type ::v-deep {
    .el-form-item__label {
      width: 100px;
    }
  }
}
.el-image {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  width: 148px;
  height: 148px;
}
.el-radio-group {
  display: inline-flex;
  align-items: center;
  .el-radio {
    flex: 1;
  }
}
</style>
